var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833374 3.33398L7.63747 8.09685C8.18845 8.48254 8.46394 8.67538 8.76359 8.75007C9.02829 8.81605 9.30513 8.81605 9.56982 8.75007C9.86948 8.67538 10.145 8.48254 10.6959 8.09685L17.5 3.33398M4.83337 14.1673H13.5C14.9002 14.1673 15.6002 14.1673 16.135 13.8948C16.6054 13.6552 16.9879 13.2727 17.2276 12.8023C17.5 12.2675 17.5 11.5674 17.5 10.1673V4.83398C17.5 3.43385 17.5 2.73379 17.2276 2.19901C16.9879 1.7286 16.6054 1.34615 16.135 1.10647C15.6002 0.833984 14.9002 0.833984 13.5 0.833984H4.83337C3.43324 0.833984 2.73318 0.833984 2.1984 1.10647C1.72799 1.34615 1.34554 1.7286 1.10586 2.19901C0.833374 2.73379 0.833374 3.43385 0.833374 4.83398V10.1673C0.833374 11.5674 0.833374 12.2675 1.10586 12.8023C1.34554 13.2727 1.72799 13.6552 2.1984 13.8948C2.73318 14.1673 3.43324 14.1673 4.83337 14.1673Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c4b82b2d4a15ce4f68794c56cfda87ce.svg";
export { ForwardRef as ReactComponent };